module.exports = __webpack_public_path__ + "img/join-us-6.d6b46758.png";